import { isFetchBaseQueryError } from 'src/types';

export const getErrorStatus = (error: unknown) => {
  if (!isFetchBaseQueryError(error)) {
    return;
  }

  return error.status;
};
